module.exports = __webpack_public_path__ + "static/media/00_centroid_calculator_card.8cc6685c.png";